
export default {
  props: ['user', 'description'],
}
